import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}
export const Portal = ({
  container,
  children
}) => {
  const [mountNode, setMountNode] = useState(null);
  useEffect(() => {
    setMountNode(getContainer(container));
  }, [container]);
  if (!mountNode) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/createPortal(children, mountNode)
  });
};